import { Routes } from '@angular/router';
import { redirectLoggedInTo, redirectUnauthorizedTo } from './guards/auth.guard';
import { requireOrg } from './guards/permission.guard';
import { requireProductAccess } from './guards/product-access.guard';
import { PLAN_PRODUCT_ID } from './core/services/product.service';

export const routes: Routes = [
  {
    // Neutral interstitial during global sign-out (no guard: shown while the
    // session is being torn down).
    path: 'signing-out',
    loadComponent: () =>
      import('./pages/signing-out/signing-out.component').then((m) => m.SigningOutComponent),
  },
  {
    // Landing for signed-in accounts that aren't in Plan's limited release
    // (non-@crewdle.com). No guard: the auth guard redirects here.
    path: 'unavailable',
    loadComponent: () =>
      import('./pages/unavailable/unavailable.component').then((m) => m.UnavailableComponent),
  },
  {
    // Data residency: the active org's region can't be reached (requireOrg).
    path: 'region-unavailable',
    loadComponent: () =>
      import('./pages/region-unavailable/region-unavailable.component').then(
        (m) => m.RegionUnavailableComponent,
      ),
    canActivate: [redirectUnauthorizedTo('/login')],
  },
  {
    // Login is centralized in the auth portal. Unauthenticated users are handed
    // off to the portal; authenticated users (e.g. the OAuth `?code=` callback
    // after re-login lands here) are redirected into the app instead of being
    // left on the signing-out loader.
    path: 'login',
    loadComponent: () =>
      import('./pages/signing-out/signing-out.component').then((m) => m.SigningOutComponent),
    canActivate: [redirectLoggedInTo('/')],
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then((m) => m.LayoutComponent),
    canActivate: [redirectUnauthorizedTo('/login')],
    children: [
      {
        path: 'new',
        loadComponent: () => import('./pages/new-org/new-org.component').then((m) => m.NewOrgComponent),
      },
      {
        path: 'board',
        loadComponent: () => import('./pages/board/board.component').then((m) => m.BoardComponent),
        canActivate: [requireOrg(), requireProductAccess(PLAN_PRODUCT_ID)],
      },
      {
        path: 'ideas',
        loadComponent: () => import('./pages/ideas/ideas.component').then((m) => m.IdeasComponent),
        canActivate: [requireOrg(), requireProductAccess(PLAN_PRODUCT_ID)],
      },
      {
        // Reachable without Plan access — explains how to enable it and
        // auto-forwards into the app once an admin turns Plan on.
        path: 'product-disabled',
        loadComponent: () =>
          import('./pages/product-disabled/product-disabled.component').then((m) => m.ProductDisabledComponent),
        canActivate: [requireOrg()],
      },
      {
        path: 'account',
        loadComponent: () => import('./pages/account/account.component').then((m) => m.AccountComponent),
      },
      {
        path: 'settings',
        redirectTo: 'account',
      },
      {
        path: '',
        redirectTo: 'board',
        pathMatch: 'full',
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
